import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  NOTIFICATIONTRIGGERS_FEATURE_KEY,
  State,
  NotificationTriggersPartialState,
  notificationTriggersAdapter,
} from './notification-triggers.reducer';

// Lookup the 'NotificationTriggers' feature state managed by NgRx
export const getNotificationTriggersState = createFeatureSelector<
  NotificationTriggersPartialState,
  State
>(NOTIFICATIONTRIGGERS_FEATURE_KEY);

const {
  selectAll,
  selectEntities,
} = notificationTriggersAdapter.getSelectors();

export const getNotificationTriggersLoaded = createSelector(
  getNotificationTriggersState,
  (state: State) => state.loaded
);

export const getNotificationTriggersError = createSelector(
  getNotificationTriggersState,
  (state: State) => state.error
);

export const getAllNotificationTriggers = createSelector(
  getNotificationTriggersState,
  (state: State) => selectAll(state)
);

export const getNotificationTriggersEntities = createSelector(
  getNotificationTriggersState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getNotificationTriggersState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getNotificationTriggersEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
